/*************************************************************************
* Copyright (c) 2025 Omnineura AI Technologies Pvt Limited.
* All rights reserved.
* This code is licensed under the 'Omnineura AI License' found in the LICENSE file.
* Unauthorized copying, sharing, or use of this code is prohibited.
* The intellectual and technical concepts are proprietary to Omnineura AI Technologies Pvt Limited.
* Author: surya@Omnineura.ai
* Date: 11-09-2025
*************************************************************************/



import { configureStore } from "@reduxjs/toolkit";
import authReducer from '../reducers/login';
import ragConfigReducer from "../reducers/ragConfigReducer" 
import documentReducer from "../reducers/uploadDocReducer"
import chatReducer from "../reducers/chatReducer"
import knowledgeBaseReducer from "../reducers/knowledgeBaseReducer"
import analyticsReducer from "../reducers/analyticsReducer"
import apiKeyReducer from "../reducers/apiKeyReducer"
import paymentReducer from "../reducers/paymentReducer"
export const store = configureStore({
  reducer: {
    
    config: ragConfigReducer,
          auth: authReducer,
          docs: documentReducer,
          chat: chatReducer,
          knowledgeBases: knowledgeBaseReducer,
          analytics: analyticsReducer,
          apiKeys: apiKeyReducer,
          payment: paymentReducer,
  },
});

